// aboutPage.js
import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import InfoBanner from '../components/InfoBanner';
import MarkdownPage from '../components/MarkdownPage';

const AboutFallback = () => (
  <div className='container-1200 container-up  container-hd'>
    <p>As per the
      <a href='https://eur-lex.europa.eu/eli/dir/2022/2555' target='_blank' rel='noopener noreferrer'> NIS2 Directive</a>,
      ENISA is mandated to develop and maintain the European vulnerability database.
    </p>
    <p>Access to reliable and timely information about vulnerabilities affecting Information and Communication Technology (ICT) products and services contributes to an enhanced cybersecurity risk management. Sources of publicly available information about vulnerabilities are an important tool for users of these services, competent authorities, and the broader cybersecurity community. ENISA has established a European Vulnerability Database (EUVD) where entities, regardless of whether they fall within the scope of the NIS2 Directive, and their suppliers of network and information systems, as well as competent authorities, most notably CSIRTs, can voluntarily disclose and register publicly known vulnerabilities to allow users to take appropriate mitigating measures.</p>
    <p>In line with Coordinated Vulnerability Disclosure practices, which aim at providing improved transparency regarding the publication process, the EUVD is eventually used to publicly disclose the vulnerability information.</p>
    <p>To avoid efforts duplication and to support complementarity, ENISA closely cooperates with MITRE and European as well as non-European operators of the Common Vulnerabilities and Exposures (CVE) system. In this context, ENISA offers vulnerability registry services after its onboarding as a CVE Numbering Authority (CNA), with a focus on vulnerabilities in IT products discovered by or reported to European CSIRTs for coordinated disclosure.</p>
    <p>Following its official launch, ENISA will continue engaging with its stakeholders to further develop and improve the EUVD service catalogue.</p>
  </div>
);

const AboutPage = () => {

  useEffect(() => {
        document.title = "About | EUVD";
      }, []);

  return (
     <>
     <Header />
     <InfoBanner />
     <main className='about'>
        <div className='banner'>
          <nav className="breadcrumbs container-1200">
            <ul>
              <li><a href="/homepage">Home</a></li>
              <li><a href="/about">About</a></li>
            </ul>
          </nav>
        </div>
        <MarkdownPage slug="about" fallback={<AboutFallback />} />
        <Banner />
      </main>
     <Footer />
     </>
  );
};

export default AboutPage;
